module.exports = __webpack_public_path__ + "img/trunk_7x4_z16.a533ef46.svg";